module.exports = __webpack_public_path__ + "img/koshaspt_SNB.58c07bce.svg";